/**
 * Cuerpo de un documento legal: índice de secciones y texto.
 *
 * Lo comparten la página pública (`/legal/:doc`) y el visor dentro de la
 * app. `idPrefix` evita ids repetidos cuando el visor se abre sobre una
 * página que ya muestra el mismo documento.
 */
import type { LegalDocument } from "@/legal/documentos";

export function LegalDocumentBody({
  doc,
  idPrefix = "",
}: {
  doc: LegalDocument;
  idPrefix?: string;
}) {
  return (
    <div className="text-sm sm:text-[15px]">
      <nav aria-label={`Secciones de ${doc.shortTitle}`} className="mb-6">
        <ul className="flex flex-wrap gap-1.5">
          {doc.sections.map((section) => (
            <li key={section.id}>
              <a
                href={`#${idPrefix}${section.id}`}
                className="inline-block rounded-full border border-slate-200 px-2.5 py-0.5 text-xs text-slate-600 hover:border-brand-300 hover:text-brand-700"
              >
                {section.title}
              </a>
            </li>
          ))}
        </ul>
      </nav>
      {doc.sections.map((section) => (
        <section
          key={section.id}
          id={`${idPrefix}${section.id}`}
          aria-labelledby={`${idPrefix}${section.id}-title`}
          className="scroll-mt-24"
        >
          <h2
            id={`${idPrefix}${section.id}-title`}
            className="mt-6 mb-2 text-base font-bold text-slate-900 sm:text-lg"
          >
            {section.title}
          </h2>
          {section.body}
        </section>
      ))}
    </div>
  );
}
